import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';

const useHeaderMockups = () => {
    const data = useStaticQuery(
        graphql`
            query {
                festival: file(relativePath: { eq: "hp/img_hp_fest_phones.png" }) {
                    childImageSharp {
                        fluid(quality: 95, maxWidth: 726) {
                            ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                    }
                }
                conference: file(relativePath: { eq: "hp/img_hp_conf_phones.png" }) {
                    childImageSharp {
                        fluid(quality: 95, maxWidth: 726) {
                            ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                    }
                }
                action: file(relativePath: { eq: "hp/img_hp_action_phones.png" }) {
                    childImageSharp {
                        fluid(quality: 95, maxWidth: 726) {
                            ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                    }
                }
            }
        `,
    );
    return useMemo(
        () =>
            Object.keys(data).reduce((acc, key) => {
                acc[key] = data[key].childImageSharp.fluid;
                return acc;
            }, {}),
        [data],
    );
};

export default useHeaderMockups;
